var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('viewer',[_c('img',{style:({
      objectFit: 'cover',
      width: '100%',
      cursor: 'pointer'
    }),attrs:{"src":_vm.src,"height":_vm.height}})])}
var staticRenderFns = []

export { render, staticRenderFns }